import { render, staticRenderFns } from "./joinComponents.vue?vue&type=template&id=51dee1bb&scoped=true"
import script from "./joinComponents.vue?vue&type=script&lang=js"
export * from "./joinComponents.vue?vue&type=script&lang=js"
import style0 from "./joinComponents.vue?vue&type=style&index=0&id=51dee1bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dee1bb",
  null
  
)

export default component.exports